// Anatomía de dato — bloque de "confianza en el número".
//
// Jerarquía FIJA (ver packages/schemas/src/jido.ts, JidoDato):
//   a) valor GRANDE (font-mono) + etiqueta chica al lado
//   b) detalle (font-mono xs) debajo
//   c) fila de chips de contexto — SIN relleno de color, solo borde
//   d) affordance discreto "ver fuente · {fuente}"
//
// El número protagonista y los chips los emite la TOOL desde la BD, nunca el
// modelo re-tipeando prosa: por eso el dato grande es imposible de alucinar.

import type { JidoDato } from 'schemas';
import { Icon } from '../../components/ui/icon';

interface DatoBloqueProps {
  dato: JidoDato;
}

export function DatoBloque({ dato }: DatoBloqueProps) {
  const { valor, etiqueta, detalle, chips, fuente } = dato;

  return (
    <div className="rounded-lg border border-border bg-surface-elevated px-4 py-3">
      {/* a) número protagonista + etiqueta */}
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
        <span className="font-mono text-3xl font-semibold leading-none text-fg">{valor}</span>
        {etiqueta ? <span className="text-sm text-fg-secondary">{etiqueta}</span> : null}
      </div>

      {/* b) detalle secundario */}
      {detalle ? <p className="mt-1.5 font-mono text-xs text-fg-secondary">{detalle}</p> : null}

      {/* c) chips de contexto rastreable */}
      {chips.length > 0 ? (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {chips.map((chip, i) => (
            <span
              key={`${chip.etiqueta}-${i}`}
              className="rounded-md border border-border px-2 py-0.5 font-mono text-xs text-fg-secondary"
            >
              {chip.etiqueta} {chip.valor}
            </span>
          ))}
        </div>
      ) : null}

      {/* d) fuente — affordance discreto, no debe competir con el número.
          Hoy solo muestra el origen; el detalle navegable requiere endpoint
          de trazabilidad (fase futura). */}
      {fuente ? (
        <button
          type="button"
          className="mt-3 inline-flex items-center gap-1 text-xs text-fg-tertiary transition-colors hover:text-fg-secondary"
        >
          <Icon name="eye" size={12} />
          <span>ver fuente · {fuente}</span>
        </button>
      ) : null}
    </div>
  );
}
